import { Card, CardContent, CircularProgress, Container, Table, TableBody, TableCell, TableRow } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import KomponenList from 'examples/Lists/KomponenList'
import { CustomDescrypt } from 'global/func'
import { postDataWithResponse } from 'global/postFunc'
import React, { useEffect, useState } from 'react'
import { decodeToken } from 'react-jwt'
import { Route, Routes } from 'react-router-dom'
import userStore from 'store/userStore'
import Komponen from '../LaporanBelanja/Komponen'

const Belanja = () => {
    return (
        <Routes>
            <Route path="" element={<Data />} />
            <Route path="komponen" element={<Komponen />} />
        </Routes>
    )
}

const Data = () => {
    const { user, addReq, tahunAnggaran } = userStore(state => ({ user: state.user, addReq: state.addReq, tahunAnggaran: state.tahunAnggaran }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        reqBelanja()
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reqBelanja = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/admin-opd/komponen-belanja/belanja',
            {
                kd_pd: decodedUser.kd_pd,
                ta: tahunAnggaran.ta,
            },
            decryptedUser,
            (res) => {
                console.log(res);
                setData(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    return (
        <ArgonBox pt={3}>
            <ArgonBox mb={3}>
                <Card>
                    <CardContent>
                        <Table aria-label="simple table">
                            <TableBody>
                                <TableRow key={0} >
                                    <TableCell sx={{ fontSize: 'small' }}>Perangkat Daerah</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {decodedUser.kd_pd} {decodedUser.nm_pd}</TableCell>
                                </TableRow>
                                <TableRow key={1} >
                                    <TableCell sx={{ fontSize: 'small' }}>Tahun Anggaran</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {tahunAnggaran.ta}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </CardContent>
                </Card>
            </ArgonBox>
            <Container>
                <ArgonBox px={2}>
                    <Card sx={{ p: 2 }}>
                        <ArgonTypography variant="h6" fontWeight="bold" textTransform="capitalize">
                            Komponen Belanja
                        </ArgonTypography>
                    </Card>
                </ArgonBox>
                {
                    loading ?
                        (
                            (
                                <ArgonBox align="center" mt={3}>
                                    <CircularProgress />
                                </ArgonBox>
                            )
                        )
                        :
                        (
                            <ArgonBox p={2}>
                                <KomponenList
                                    title="Proyek DAK"
                                    listData={data}
                                    to='/a-pd/belanja/komponen'
                                    showOpd={false}
                                    showLastUpdate={true}
                                />
                            </ArgonBox>
                        )
                }
            </Container>
        </ArgonBox>
    )
}

export default Belanja